module.exports = __webpack_public_path__ + "img/gc_country_flag_ro.45ada31b.svg";